import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-view-skeleton-template',
  templateUrl: './edit-view-skeleton-template.component.html',
  styleUrls: ['./edit-view-skeleton-template.component.scss'],
})
export class EditViewSkeletonTemplateComponent {
  counter(i: number) {
    return new Array(i);
  }
}
